import { Text } from '../Text';
import React from 'react';
export var createHighlighted = function (fullString, currentLocation, lengthOfQueryString) {
    return (React.createElement(Text, { size: 2, weight: "heavy" }, fullString.slice(currentLocation, currentLocation + lengthOfQueryString)));
};
export var createUnhighlighted = function (fullString, previousQueryStringLocation, currentQueryStringLocation) {
    return (React.createElement(Text, { size: 2 }, fullString.slice(previousQueryStringLocation, currentQueryStringLocation)));
};
export var isValidQuery = function (query) {
    var invalidFirstChars = ['*', '+'];
    var isValid = true;
    invalidFirstChars.forEach(function (char) {
        if (query[0] === char)
            isValid = false;
    });
    if (query.includes('\\'))
        isValid = false;
    return isValid;
};
